import React, { useEffect } from "react";
import Layout from "./layout";
import ListOrderMasuk from "../component/ListOrderMasuk";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice";

const OrderMasuk = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);
  return (
    <Layout>
      <ListOrderMasuk />
    </Layout>
  );
};

export default OrderMasuk;
